import { useEffect, useState } from "react";
import { api } from "@/App";

// Only Autotuner has actual logo assets. Alientech/MagicMotorsport rows
// carry no logo of their own, so their pages/search views look the brand
// name up here (by lowercased match) and simply render nothing if the
// brand isn't in Autotuner's catalogue. Fetched once and cached module-wide
// since the map is the same for every page/component that needs it.
let cache = null;
let inflight = null;

export function useBrandLogos() {
  const [logos, setLogos] = useState(cache || {});

  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = api
        .get("/brand-logos")
        .then(({ data }) => {
          cache = data;
          return data;
        })
        .catch(() => ({}));
    }
    inflight.then((data) => setLogos(data));
  }, []);

  return logos;
}

export function brandLogoFor(logos, brand) {
  if (!brand) return null;
  return logos[brand.toLowerCase()] || null;
}
